import { InfoWithLabel } from "@/core/components/info-with-label";
import { Typography } from "@/core/components/ui/typography";
import { ISpiff, SpiffTriggerPlaceholderTrigger } from "@/spiffs/spiffs.d";

interface PlaceholderTriggerDetailsProps {
  spiff: ISpiff;
}

export const PlaceholderTriggerDetails = ({
  spiff,
}: PlaceholderTriggerDetailsProps) => {
  const placeholderTrigger = spiff.trigger as SpiffTriggerPlaceholderTrigger;

  // For placeholder triggers (driving_score, tech_generated_lead), show public notes
  const notes = placeholderTrigger.public_notes;

  if (!notes) {
    return (
      <InfoWithLabel label="Notes">
        <Typography variant="bodyW1" textColor="secondary">
          No additional information
        </Typography>
      </InfoWithLabel>
    );
  }

  return (
    <InfoWithLabel label="Notes">
      <Typography variant="bodyW1">{notes}</Typography>
    </InfoWithLabel>
  );
};
